<h2 class="sk-page-title">Services</h2>
<p class="sk-page-blurb">
  BestRoute integrates a range of powerful external services. Use them to complete
  different tasks based on your needs.
</p>

<!-- One panel per category (Agent / Maps). The title carries a segmented
     selector of the methods the category offers — CLI (where a sign-in exists) and
     API keys; the selected one's content shows below. Single-method categories get a
     one-segment selector. -->
<ng-container *ngIf="!loading && !error">
  <div class="tc-card br-card sk-card" *ngFor="let svc of panels; trackBy: trackService">
    <header class="tc-toolbar sk-header">
      <h2 class="sk-cat">{{ svc.label }}</h2>
      <div class="sk-methods" role="tablist" aria-label="Connection method">
        <button type="button" class="sk-method" role="tab" *ngIf="svc.hasCliLogin"
                [class.on]="connectionMethodOf(svc) === 'cli'" [attr.aria-selected]="connectionMethodOf(svc) === 'cli'"
                (click)="setConnectionMethod(svc, 'cli')">CLI</button>
        <button type="button" class="sk-method" role="tab"
                [class.on]="connectionMethodOf(svc) === 'api'" [attr.aria-selected]="connectionMethodOf(svc) === 'api'"
                (click)="setConnectionMethod(svc, 'api')">API keys</button>
      </div>
    </header>

    <!-- CLI sign-in — shown when the CLI method is selected (the agent). -->
    <app-cli-providers *ngIf="svc.hasCliLogin && connectionMethodOf(svc) === 'cli'"></app-cli-providers>

    <app-api-key-list *ngIf="connectionMethodOf(svc) === 'api'" [service]="svc"></app-api-key-list>
  </div>
</ng-container>

<app-voice-settings></app-voice-settings>

<div class="tc-loading" *ngIf="loading">Loading…</div>

<div class="br-flex br-items-center br-gap-2" *ngIf="error" role="alert">
  <span>{{ error }}</span><button type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="load()">Retry</button>
</div>
